module.exports = __webpack_public_path__ + "img/new11.ad94cb42.jpg";